import {Grid} from "@mui/material";
import * as React from "react";
import Spinner from "../spinner";

export default function PageLoader() {
    return (
        <Grid container justifyContent="center"
              sx={{height: "70vh"}}
              alignItems="center">
            <Spinner/>
        </Grid>
    );
}